import React, { useRef } from "react";
import Css from "./SingalCertificate.module.css";
import { Certificates } from "../APIS";
import { useNavigate, useParams } from "react-router-dom";
const SingalCerificate = () => {
  const { id } = useParams();
  const selecetBg = Certificates.filter((e) => e.id == id);
  //   const styles = {
  //     image: {
  //         transition: 'transform 0.1s ease-out'  // تأثير التحويل التدريجي
  //     }
  // };

  // const [transform, setTransform] = useState('translate(0, 0) scale(1)');
  // const containerRef = useRef(null);

  // const handleClick = (event) => {
  //     const container = containerRef.current;
  //     const containerRect = container.getBoundingClientRect();
  //     const mouseX = event.clientX - containerRect.left;
  //     const mouseY = event.clientY - containerRect.top;
  //     const containerWidth = containerRect.width;
  //     const containerHeight = containerRect.height;
  //     const percentX = mouseX / containerWidth;
  //     const percentY = mouseY / containerHeight;
  //     const scale = 1.5;  // قيمة التكبير
  //     const translateX = (percentX - 0.5) * (containerWidth * (scale - 1));
  //     const translateY = (percentY - 0.5) * (containerHeight * (scale - 1));

  //     setTransform(`translate(${translateX}px, ${translateY}px) scale(${scale})`);
  // };

  // const handleReset = () => {
  //     setTransform('translate(0, 0) scale(1)');
  // };
  const parent = useRef(null);
  const Path = useNavigate()
  const handleClick = () => {
    if (parent.current) {
      Path("/")
    }else{

    }
  };
  return (
    <div>
      <div ref={parent} className={`${Css.parent}`}>
        <div className={Css.container} onClick={() => handleClick()}>
          {selecetBg?.map((e, index) => (
            <div className={Css.card} key={index}>
              <img id="img" src={e.image} alt="" />
            </div>
          ))}
        </div>
        <button onClick={() => handleClick()}>X</button>
      </div>
    </div>
  );
};

export default SingalCerificate;
